import { useEffect, useState } from "react";
import { Info, X } from "lucide-react";
import { getSeenHints, markHintSeen } from "@/lib/api";

const KEY = "short_explainer";

export function ShortHint({ active, testid = "short-hint", className = "" }) {
  const [seen, setSeen] = useState(true);

  useEffect(() => {
    getSeenHints().then(r => setSeen((r.data?.seen || []).includes(KEY))).catch(() => {});
    const onSeen = () => setSeen(true);
    window.addEventListener("short-hint-seen", onSeen);
    return () => window.removeEventListener("short-hint-seen", onSeen);
  }, []);

  if (!active || seen) return null;

  const dismiss = () => {
    setSeen(true);
    window.dispatchEvent(new Event("short-hint-seen"));
    markHintSeen(KEY).catch(() => {});
  };

  return (
    <div className={`${className} flex items-start gap-2 px-3 py-2 bg-bt-gold/10 border border-bt-gold/30 text-xs text-bt-text-secondary animate-in fade-in slide-in-from-top-1 duration-300`} data-testid={testid}>
      <Info className="w-3.5 h-3.5 text-bt-gold mt-0.5 shrink-0" />
      <p className="flex-1"><span className="text-bt-gold font-medium">How shorts work:</span> you profit when the price falls below your short price and lose when it rises — losses have no ceiling.</p>
      <button onClick={dismiss} className="text-bt-text-tertiary hover:text-bt-gold transition-colors" aria-label="Dismiss" data-testid={`${testid}-dismiss`}><X className="w-3.5 h-3.5" /></button>
    </div>
  );
}
